import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiToast } from '@hooks/useApiToast';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import type {
  CreateWorkOrderDocumentCommand,
  WorkOrderDocumentViewModel
} from '../../openapi';

type CreateWorkOrderDocumentParams = {
  jobNumber: string;
  documentData: CreateWorkOrderDocumentCommand;
  showToast?: boolean;
};

export const useCreateWorkOrderDocument = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useApiToast();
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useMutation<
    WorkOrderDocumentViewModel,
    Error,
    CreateWorkOrderDocumentParams
  >({
    mutationFn: async ({ jobNumber, documentData }) => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberDocumentsPost({
        jobNumber,
        createWorkOrderDocumentCommand: documentData
      });
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['workorders', 'documents', variables.jobNumber]
      });
      queryClient.invalidateQueries({
        queryKey: ['workorders', variables.jobNumber]
      });
      if (variables.showToast !== false) {
        showSuccess(
          'customerAcknowledgment.signatureSubmitted',
          'customerReview'
        );
      }
    },
    onError: error => {
      showError(
        'customerAcknowledgment.signatureSubmitFailed',
        error,
        'customerReview'
      );
    }
  });
};
